import { createContext } from 'react'

import { type AppInsightsContextType } from '../types/context'

// Create context with a default empty implementation
const AppInsightsContext = createContext<AppInsightsContextType>({
  identify: () => {},
  capture: () => {},
  group: () => {},
  clearGroup: () => {},
  enable: () => {},
  disable: () => {},
  isEnabled: () => false,
  setDebugMode: () => {},
  getContext: () => ({}),
  trackPageView: () => {},
  configurePageTracking: () => {},
  appInsights: null as any,
  userContext: null as any,
  groupContext: null as any
})

export default AppInsightsContext
